import { lowercaseKeys, tunnelTranslation } from '../../utils/tunnel-translation';

/**
 * Libellés de la timeline de paiement/remboursement — contrat partagé par le tunnel booking
 * classique (`BookingLabels`) et le tunnel VTC (`RideLabels`), consommés par le composant
 * `PaymentTimeline`. Chaînes dans `@cfixe/shared` (`BOOKING_TUNNEL_TIMELINE`) : les deux jeux de labels
 * étalent `DEFAULT_PAYMENT_TIMELINE_LABELS` (pas de duplication).
 */
export interface PaymentTimelineLabels {
  from_price_prefix: string;
  voucher_info_applied_generic: string;
  timeline_title: string;
  timeline_now: string;
  timeline_until: string;
  timeline_after_deadline: string;
  timeline_now_no_cancel: string;
  timeline_day_of: string;
  timeline_free_cancel_until: string;
  timeline_cancel_before: string;
  timeline_no_charge_until: string;
  timeline_deposit_charged: string;
  timeline_full_charged: string;
  timeline_imprint_held: string;
  timeline_imprint_chargeable: string;
  timeline_imprint_released: string;
  timeline_card_saved: string;
  timeline_booking_confirmed: string;
  timeline_no_cancel_possible: string;
  timeline_attendance_commitment: string;
  timeline_no_charge_after_deadline: string;
  timeline_non_refundable: string;
  timeline_partial_refund_after: string;
  timeline_cancellation_fee_attempt: string;
  timeline_cancellation_fee_can_apply: string;
  timeline_pay_on_site: string;
  timeline_nothing_on_site: string;
  timeline_price_to_determine_on_site: string;
  timeline_amount_charged: string;
  timeline_amount_refundable: string;
  timeline_amount_non_refundable: string;
  timeline_amount_remaining: string;
  timeline_amount_cancellation_fee: string;
  timeline_voucher_label: string;
  timeline_voucher_refund: string;
  timeline_voucher_no_refund: string;
}

/** Libellés de la frise dans une langue (`BOOKING_TUNNEL_TIMELINE`, repli sur le français). */
export const paymentTimelineLabelsFor = (locale = 'fr-FR'): PaymentTimelineLabels =>
  lowercaseKeys(tunnelTranslation(locale, 'BOOKING_TUNNEL_TIMELINE'));

export const DEFAULT_PAYMENT_TIMELINE_LABELS: PaymentTimelineLabels = paymentTimelineLabelsFor('fr-FR');
